const APP = 'HORIZON';
export const ROSTR_OVERVIEW_INITIAL_DATE = `${APP}_ROSTR_OVERVIEW_INITIAL_DATE`;
export const ROSTR_TIMELINE_FILTER_DATA_FOR_SCHEDULES = `${APP}_ROSTR_TIMELINE_FILTER_DATA_FOR_SCHEDULES`;
export const AGENDA_TIMELINE_FILTER_DATA_FOR_GROUPS = `${APP}_AGENDA_TIMELINE_FILTER_DATA_FOR_GROUPS`;
